module.exports = __webpack_public_path__ + "static/img/rank_57.734541a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_57.png
// module id = kfWZ
// module chunks = 1